<template>
  <div v-show="!isProjectListRoute" class="navbar">
    <!-- <img :src="logo" class="sidebar-logo" /> -->
    <div class="info">
      <breadcrumb id="breadcrumb-container" class="breadcrumb-container" />
    </div>
    <!-- <div class="centerLock">
      <el-button
        v-clickLock="changeEditRead"
        szie="mini"
        type="text"
        :icon="EditRead ? 'el-icon-lock' : 'el-icon-unlock'"
        :style="{ color: EditRead ? 'red' : '#67c23a' }"
        class="lockBtn"
      >
        {{ EditRead ? "只读(XXX正在编辑)" : "编辑模式" }}
      </el-button>
    </div> -->

    <div class="right">
      <template v-if="saveModule && !isAndroidOnline">
        <span
          v-if="!isSaveLoading && isSaveTips"
          style="padding-top: 4px"
          class="ydb-text-save"
          >{{ isSaveTips }}
          <el-tooltip class="item" effect="dark">
            <div slot="content">
              检测数据已上报，如需更改模型或检测数据，请至鉴定检测复核模块点击重新上报按钮解锁数据
            </div>
            <i class="el-icon-question"></i> </el-tooltip
        ></span>
        <span v-else-if="!isSaveLoading && push_time" class="ydb-text"
          >更新时间:{{ push_time }}</span
        >
        <span v-else-if="isSaveLoading" class="ydb-text-save">保存中...</span>
      </template>
      <template v-if="isRoloadWs && !isWsError">
        <span class="reconnect-ws-warning">websocket重连中...</span>
      </template>
      <template v-if="isWsError">
        <span class="reconnect-ws" @click="reconnectWs"
          >网络存储已断开，为防数据丢失，请点击重连</span
        >
        <span v-if="!getIsAndroid" class="down-cache" @click="downCache"
          >下载模型数据</span
        >
        <span @click="pushModelData" class="synchronous"
          >同步模型数据到服务器</span
        >
      </template>
      <!-- <span @click="pushModelData" class="synchronous"
        >同步模型数据到服务器</span
      > -->
      <!-- <span v-if="lock && saveModule" class="tips">
        暂无操作权限
        <el-tooltip class="item" effect="dark">
          <div slot="content">
            当前项目模型被占用中，如需操作模型，请联系占用用户解锁。<br />（查看占用用户请点击右侧
            <i class="el-icon-user-solid"></i>）
          </div>
          <i class="el-icon-question"></i>
        </el-tooltip>
      </span> -->
      <template v-if="lock && saveModule && !canReoperate">
        <el-tooltip
          v-if="!isApplyIng"
          class="item"
          effect="dark"
          :content="lockTips"
        >
          <div slot="content">
            {{ lockTips }}
          </div>
          <span
            @click="wunlockapplyAction"
            class="tips"
            style="padding-left: 0px"
            >暂无操作权限，<i class="apply-btn">申请解锁</i></span
          >
        </el-tooltip>
        <span class="rightInfo tips" v-else>申请解锁中</span>
      </template>
      <span
        v-if="canForedUnloack"
        class="rightInfo"
        style="padding-left: 0px; color: #f56c6c"
        @click="forcedUnlocking"
        >强制解锁</span
      >
      <span
        v-if="saveModule && !lock"
        v-clickLock="saveModuleClick"
        class="rightInfo"
        id="navbar-save-btn"
      >
        <svg-icon icon-class="save" />
        保存
      </span>
      <el-divider
        v-if="saveModule && canexport && !lock"
        direction="vertical"
      ></el-divider>
      <span
        v-show="canexport"
        class="rightInfo"
        @click="modalShowDerive = true"
        id="navbar-export-btn"
      >
        <svg-icon icon-class="export"></svg-icon>
        导出
      </span>
      <el-divider v-if="saveModule && !lock" direction="vertical" />
      <span
        v-if="saveModule && !lock"
        v-clickLock="revokeModuleClick"
        :class="
          revokeDataLength > 1 && !viewFlag && !isAxisNaming
            ? 'rightInfo'
            : 'revokeBtn'
        "
      >
        <svg-icon icon-class="revoke" />
        撤销
      </span>
      <span
        v-if="saveModule && !lock"
        v-clickLock="rollbackModuleClick"
        :class="
          revokeRollbackLength > 0 && !viewFlag && !isAxisNaming
            ? 'rightInfo'
            : 'revokeBtn'
        "
      >
        <svg-icon icon-class="rollback" />
        回退
      </span>
      <el-divider direction="vertical" />
      <screenfull
        v-if="!getIsAndroid"
        id="screenfull"
        class="right-menu-item hover-effect rightInfo"
      />
      <el-divider v-if="!getIsAndroid" direction="vertical" />

      <!-- 系统设置 -->
      <div v-for="drop in routerList" v-show="!navPageBol" :key="drop.id">
        <el-dropdown trigger="click" @command="handleCommand">
          <span class="el-dropdown-link">
            <i :class="drop.icon" /> {{ drop.title }}
          </span>
          <el-dropdown-menu slot="dropdown" style="padding: 0">
            <el-dropdown-item
              v-for="chilDrop in drop.children"
              :key="chilDrop.key"
              :command="chilDrop.key ? chilDrop.key : ''"
            >
              {{ chilDrop.label }}
            </el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-divider direction="vertical" />
        <!-- 软件信息 -->
      </div>
      <!-- 部门 -->
      <!-- <span v-if="!isMobile" class="rightInfo">
        <svg-icon icon-class="organization" />
        {{ userInfo.customer_name }}
      </span> -->
      <!-- <el-divider v-if="!isMobile" direction="vertical" /> -->
      <!-- 软件信息 -->
      <el-dropdown trigger="click">
        <span class="el-dropdown-link">
          <i class="el-icon-user-solid" /> {{ userInfo.name }}
        </span>
        <el-dropdown-menu slot="dropdown" style="padding: 0">
          <el-dropdown-item
            :key="item.user_id"
            v-for="item in userList"
            :command="item.user_id"
            >{{ item.name }}
            <span
              :class="{
                isLock: item.lock === 1,
                isNoLock: item.lock === 0,
              }"
              >({{ item.lock === 1 ? "占用" : "锁住" }})</span
            ></el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
      <el-divider v-if="!isMobile" direction="vertical" />
      <template v-if="!isAndroidOnline">
        <el-popover trigger="manual" v-if="!lock" ref="myPopover">
          <div class="popover-content">
            设置锁定时间
            <el-input-number
              controls-position="right"
              size="small"
              v-model="time"
              :min="1"
              :max="168"
              style="width: 90px"
              :precision="0"
            ></el-input-number>
            <!-- <el-input-number
              controls-position="right"
              size="small"
              v-model="time"
              :max="168"
              style="width: 90px"
            ></el-input-number> -->
            小时
            <el-button type="primary" size="mini" @click="setLockTimeAction"
              >确定</el-button
            >
            <el-button type="danger" size="mini" @click="checkout"
              >解锁</el-button
            >
          </div>
          <span
            @click="togglePopover"
            ref="trigger1"
            slot="reference"
            size="mini"
            class="rightInfo"
          >
            解锁
            <i
              style="
                color: #f56c6c;
                font-style: normal;
                font-weight: normal;
                font-size: 12px;
              "
              >到期时间:{{ lockTime || "未设置" }}</i
            >
          </span>
        </el-popover>
        <span class="rightInfo" v-if="canReoperate" @click="reoperate">
          继续操作
        </span>
      </template>
      <span class="rightInfo" @click="getLogout"> 结束检测 </span>
      <!-- 个人信息弹框盒子 -->
      <vxe-modal v-model="modalShow" show-zoom resize destroy-on-close>
        <changePassword v-if="userCommand" @close="modalShow = false" />
        <userInfo v-else />
      </vxe-modal>
      <!-- 导出功能弹窗 -->
      <vxe-modal
        v-model="modalShowDerive"
        destroy-on-close
        width="250px"
        height="355px"
        title="数据导出"
        :z-index="1000"
      >
        <Derive v-if="modalShowDerive" @close="modalShowDerive = false" />
      </vxe-modal>
    </div>
  </div>
</template>

<script>
// 模型导出
import { exportData } from "@/api/upload";
import userInfo from "./userInfo.vue";
import { mapGetters } from "vuex";
import changePassword from "@/layout/components/infoDom/changePassword.vue";
import { VXETable } from "vxe-table";
import Breadcrumb from "@/components/Breadcrumb";
import Screenfull from "@/components/Screenfull";

import { transferLocalData } from "@/utils/indexedDBModule/saveAllModules.js";
import { Re_Do } from "@/rlMxModules/operate/Re_UndoOperate";
import {
  rollbackRevoke,
  initRevokeReDoData,
} from "@/rlMxModules/operate/revokeRollback.js";
import { detectionUrl } from "@/const/request_api";
import {
  showFullScreenLoading,
  tryHideFullScreenLoading,
} from "@/utils/loading";
import { goBack, getIsAndroid, isAndroidOnline } from "@/api/androidApi";
import { isMobileDevice } from "@/utils/matchMedia.js";
import { getInputElement } from "@/rlMxModules/operate/inputElement";
import {
  fetchAndDownloadWithDexie,
  getAllDataWithDexie,
} from "@/mixins/LiteModuleDb.js";
import { unlock, lock as lockAction, pushModelData } from "@/api/user.js";
import { wunlock, wunlockapply, setLockTime } from "@/api/project.js";
import Derive from "./derive/derive.vue";
export default {
  components: {
    Breadcrumb,
    userInfo,
    changePassword,
    Screenfull,
    Derive,
  },
  data() {
    return {
      userCommand: 0, // 个人信息选项
      modalShow: false, // 个人信息弹框
      modalShowDerive: false, // 导出功能弹框
      logo: require("@/assets/images/newlabel.png"),
      time: 1,
    };
  },
  computed: {
    ...mapGetters([
      "sidebar",
      "routerList",
      "userInfo",
      "rlProject_id",
      "rlProject_name",
      "topBtnActive",
      "isPcMode",
      "revokeDataLength",
      "revokeRollbackLength",
      "isAxisNaming",
      "menuData",
      "viewFlag",
      "EditRead",
      "isInCommand",
      "isMoveOrCopy",
      "isRoloadWs",
      "isWsError",
      "userList",
      "lock",
      "push_time",
      "isSaveLoading",
      "isSaveTips",
      "rlProject_detail",
      "applicationList",
    ]),
    navPageBol() {
      const hasDetection = this.$route.path.includes("inspectionLite");
      return hasDetection;
    },
    // 是否需要顶部保存按钮
    saveModule() {
      return this.menuData?.key === "detection";
    },
    // 根据路由判断是否是显示顶部导航
    isProjectListRoute() {
      return this.$route.path.includes("/mobileViews/projectList");
    },
    isMobile() {
      return isMobileDevice();
    },
    getIsAndroid() {
      return getIsAndroid();
    },
    canexport() {
      return !isAndroidOnline();
    },
    isAndroidOnline() {
      return isAndroidOnline();
    },
    lockTips() {
      const lockName = this.userList?.find((e) => e.lock === 1);
      // console.log("lockName", lockName);
      return `此项目被${lockName?.name}占用中，模型操作已锁定，您可申请解锁！`;
    },
    canForedUnloack() {
      return (
        this.lock &&
        this.rlProject_detail?.create_id === this.userInfo?.id &&
        this.applicationList?.length > 0 &&
        this.applicationList?.findIndex(
          (e) => e?.user_id === this.userInfo?.id
        ) > -1
      );
    },
    isApplyIng() {
      return (
        this.applicationList?.length > 0 &&
        this.applicationList?.findIndex(
          (e) => e?.user_id === this.userInfo?.id
        ) > -1
      );
    },
    lockTime() {
      const lockName = this.userList?.find((e) => e.lock === 1);
      return lockName?.lock_time || "未设置";
    },
    canReoperate() {
      return (
        this.lock &&
        this.userList &&
        this.userList.length === 1 &&
        this.userInfo &&
        this.userInfo.id &&
        this.userList[0].user_id &&
        this.userList[0].user_id === this.userInfo.id
      );
    },
  },

  methods: {
    togglePopover() {
      const popover = this.$refs.myPopover;
      // 切换显示状态：显示则隐藏，隐藏则显示
      popover.showPopper ? popover.doClose() : popover.doShow();
    },
    initMobilePopoverClose() {
      // 保存事件处理函数的引用
      this.touchHandler = (e) => {
        const popover = this.$refs.myPopover;
        const trigger = this.$refs.popoverTrigger;

        // 如果popover未显示，直接返回，不做任何处理
        if (!popover || !popover.showPopper) return;

        // 关键修改：获取弹窗浮层的实际DOM元素（popperElm）
        const popoverContentEl = popover.popperElm;
        // 判读点击目标是否在【触发元素】或【弹窗浮层】内部
        const isClickInside =
          (trigger && trigger.$el.contains(e.target)) || // 触发元素内部
          (popoverContentEl && popoverContentEl.contains(e.target)); // 弹窗浮层内部

        // 如果触摸在外部，才关闭popover
        if (!isClickInside) {
          popover.doClose();
        }
      };

      // 监听document的touchstart事件，添加passive: true优化移动端性能
      document.addEventListener("touchstart", this.touchHandler, {
        passive: true,
      });
    },
    // 通用的移动端popover关闭方法
    mobilePopoverClose(popoverRefs, triggerRefs) {
      document.addEventListener("touchstart", (e) => {
        popoverRefs.forEach((popoverRef, index) => {
          const popover = this.$refs[popoverRef];
          const trigger = this.$refs[triggerRefs[index]];
          if (!popover || !popover.showPopper) return;
          const isClickInside =
            popover.$el?.contains(e.target) ||
            (trigger && trigger.$el?.contains(e.target));
          if (!isClickInside) {
            popover.doClose();
          }
        });
      });
    },
    async setLockTimeAction() {
      await setLockTime({
        project_id: this.rlProject_id,
        time: this.time,
      });
      this.$message.success("设置锁定时间成功！");
    },
    async wunlockapplyAction() {
      await wunlockapply({
        project_id: this.rlProject_id,
      });
      this.$message.success("申请解锁成功，请等待占用用户同意！");
    },
    async forcedUnlocking() {
      const lockName = this.userList && this.userList.find((e) => e.lock === 1);
      this.$confirm(
        `项目被${lockName?.name}占用中，是否确认强制解锁?`,
        "提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        }
      )
        .then(async () => {
          await wunlock({
            project_id: this.rlProject_id,
          });
          this.$message.success("强制解锁成功！");
        })
        .catch(() => {});
    },
    pushModelData() {
      showFullScreenLoading("模型数据同步中...");
      setTimeout(async () => {
        const value = await getAllDataWithDexie(`project${this.rlProject_id}`);
        pushModelData({
          project_id: this.rlProject_id,
          json: JSON.stringify(value),
          type: 1,
        })
          .then(() => {
            this.$message.success("同步模型成功！");
          })
          .finally(() => {
            tryHideFullScreenLoading();
          });
      }, 1000);
    },
    checkout() {
      this.$confirm("解锁将失去操作模型权限, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          unlock({
            project_id: this.rlProject_id,
          });
        })
        .catch(() => {});
    },
    reoperate() {
      this.$confirm("继续操作会占用操作模型权限, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          lockAction({
            project_id: this.rlProject_id,
          });
        })
        .catch(() => {});
    },
    toggleSideBar() {
      this.$store.dispatch("app/toggleSideBar");
    },

    // 注销/退出登录
    async getLogout() {
      const type = await VXETable.modal.confirm("您确定要结束检测吗？");
      if (type === "confirm") {
        if (getIsAndroid()) {
          goBack();
        } else {
          this.$store.commit(
            "user/logout",
            "/login?redirect=" + this.$route.fullPath
          );

          window.location.replace(
            `${detectionUrl}/#/project-manage/project-management`
          );
        }
      }
    },
    // 修改个人信息
    changeUserInfo(com) {
      this.modalShow = true;
      this.userCommand = com;
    },
    // 路由跳转
    handleCommand(command) {
      if (command) {
        this.$router.push(command);
      }
    },
    // 保存模型
    async saveModuleClick() {
      try {
        this.$showFullScreenLoading("保存中...");
        await new Promise((resolve) => setTimeout(resolve, 200));
        await transferLocalData(this.rlProject_id, "modelingData", 1);
        tryHideFullScreenLoading();
      } catch (error) {
        tryHideFullScreenLoading();
      }
    },
    // 导出模型
    async exportModuleClick() {
      try {
        showFullScreenLoading("导出中...");
        const { data } = await exportData({ project_id: this.rlProject_id });
        if (data.url) {
          const iframe = document.createElement("iframe");
          iframe.style.display = "none";
          iframe.src = data.url;
          iframe.onload = () => {
            document.body.removeChild(iframe);
          };
          document.body.appendChild(iframe);
        }
        this.$message.success("导出成功");
        tryHideFullScreenLoading();
      } catch (error) {
        tryHideFullScreenLoading();
      }
    },
    // 撤销
    async revokeModuleClick() {
      if (this.revokeDataLength <= 1) {
        return;
      }
      if (this.isInCommand || this.isMoveOrCopy) {
        let inputElement = getInputElement();
        if (inputElement && inputElement.style.display == "block") {
          this.$message.warning("正在执行命令，请稍后再试");
          return;
        }
      }
      this.$store.commit("globalData/SET_REDO", true);
      await rollbackRevoke();
      await Re_Do();
    },
    // 回退
    async rollbackModuleClick() {
      if (this.revokeRollbackLength < 1) {
        return;
      }
      if (this.isInCommand || this.isMoveOrCopy) {
        let inputElement = getInputElement();
        if (inputElement && inputElement.style.display == "block") {
          this.$message.warning("正在执行命令，请稍后再试");
          return;
        }
      }
      this.$store.commit("globalData/SET_REDO", true);
      await Re_Do(true);
    },

    // 切换 只读/编辑 模式
    async changeEditRead() {
      this.$store.commit("platBtns/CHANGE_EDITREAD", !this.EditRead);
    },
    downCache() {
      fetchAndDownloadWithDexie(
        `project${this.rlProject_id}`,
        `project-${this.rlProject_id}-${new Date().getTime()}`
      );
    },
    reconnectWs() {
      // this.$store.state.app.isRoloadWs = true;
      this.$store.state.app.isWsError = false;
      this.$socketApi.webSocketOnClose(
        {
          code: 1006,
        },
        0
      );
      // changeReConnectNum(0);
      // webSocketOnClose();
    },
  },
  mounted() {
    this.initMobilePopoverClose();
  },
  beforeDestroy() {
    // 注意：如果是批量监听，需要保存事件处理函数的引用，再移除
    // 这里简化处理，实际项目中可优化为保存引用后移除
    if (this.touchHandler) {
      document.removeEventListener("touchstart", this.touchHandler, {
        passive: true,
      });
    }
  },
};
</script>

<style lang="scss" scoped>
.navbar {
  height: 30px; // 50px
  background-color: #fff;
  color: #000;
  display: flex;
  align-items: center;
  // align-items: flex-end;
  .moduleBtns {
    // ::v-deep .el-button--mini {
    //   padding: 5px 8px;
    // }
    margin-left: 10px;
    .moduleTitle {
      margin-left: 10px;
      font-size: 14px;
      font-weight: 700;
    }
  }

  .info {
    // flex: 1;
    .tip {
      background-color: #fff;
      padding: 3px 8px;
      border-radius: 8px;
      font-size: 14px;
      margin-left: 10px;
    }
  }

  .sidebar-logo {
    width: 36px;
    height: 36px;
    vertical-align: middle;
    margin-left: 3px;
    border-radius: 50%;
  }
  .centerLock {
    flex: 1;
  }

  .right {
    display: flex;
    align-items: center;
    // align-items: flex-end;
    margin-right: 20px;
    flex: 1;
    justify-content: end;

    .infoBox {
      text-align: center;
      line-height: 20px;
    }

    .avatar {
      width: 20px;
      height: 20px;
      margin-right: 2px;
      border-radius: 50%;
    }

    .rightInfo {
      padding-left: 5px;
      vertical-align: middle;
      font-size: 14px;
      font-weight: 550;
      cursor: pointer;
    }

    .revokeBtn {
      padding-left: 5px;
      vertical-align: middle;
      font-size: 14px;
      font-weight: 550;
      cursor: not-allowed; //禁止光标
      color: #666;
    }

    .icon-color {
      margin-left: 5px;
      color: #fff;
    }
  }
  .changeUserInfo {
    cursor: pointer;
  }
  ::v-deep .el-divider {
    background-color: #000;
  }
  ::v-deep .el-dropdown {
    color: #000;
    font-weight: 700;
    font-size: 14px;
    cursor: pointer;
    padding: 0;
  }
  .lockBtn {
    padding: 0;
  }
}

@media (max-width: 900px) {
  .navbar,
  .lockBtn,
  .revokeBtn,
  .navbar .right .rightInfo,
  ::v-deep .app-breadcrumb.el-breadcrumb,
  ::v-deep .el-dropdown {
    font-size: 12px !important;
    line-height: 12px;
  }
}
@media (max-width: 600px) {
  .navbar,
  .lockBtn,
  .revokeBtn,
  .navbar .right .rightInfo,
  ::v-deep .app-breadcrumb.el-breadcrumb,
  ::v-deep .el-dropdown {
    font-size: 10px !important;
    line-height: 10px;
  }
}
.reconnect-ws-warning {
  color: #f56c6c;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
}
.reconnect-ws {
  color: #e6a23c;
  font-weight: 600;
  margin-right: 10px;
  cursor: pointer;
  font-size: 14px;
}
.down-cache {
  color: #67c23a;
  font-weight: 600;
  cursor: pointer;
  font-size: 14px;
}
.synchronous {
  color: #409eff;
  margin-left: 10px;
  font-size: 14px;
  cursor: pointer;
  font-weight: 600;
}
.isLock {
  color: #67c23a;
}
.isNoLock {
  color: #f56c6c;
}
.ydb-text {
  color: #67c23a;
  font-size: 12px;
  margin-right: 10px;
  position: relative;
  top: 2px;
}
.ydb-text-save {
  color: #f56c6c;
  font-size: 12px;
  margin-right: 10px;
}
.tips {
  color: #e6a23c;
  font-size: 12px;
  // font-weight: 600;
  margin-right: 10px;
  position: relative;
}
.apply-btn {
  color: #67c23a;
  cursor: pointer;
  font-style: normal;
  font-weight: 700;
}
</style>
